export default "__VITE_PUBLIC_ASSET__10af4bf2__"